import React from "react";
import { Link } from "react-router-dom";
import Header from "./main/header";
import Nav from "./main/nav";
import Footer from "./main/footer";
export default function LiveLocation() {
  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <h1 className="text-center text-primary">
                  Welcome to Live Location
                </h1>
                <div className="row">
                  <div className="card">
                    <div className="card-body px-1">
                      <div className="table-responsive text-nowrap">
                        <table className="table table-hover table-font table-striped">
                          <thead>
                            <tr className="table-primary">
                              <td>Serial No.</td>
                              <td>Container No.</td>
                              <td>Container Size</td>
                              <td>Container Type</td>
                              <td>Location</td>
                              <td>Timestamp</td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <span>1</span>
                              </td>
                              <td>
                                <span>hjh8767676</span>
                              </td>
                              <td>
                                <span>40 Ft</span>
                              </td>
                              <td>
                                <span>HQ</span>
                              </td>
                              <td>
                                <span>-</span>
                              </td>
                              <td>
                                <span>11:07:2024 13:52:00</span>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <span>2</span>
                              </td>
                              <td>
                                <span>hjh87457876</span>
                              </td>
                              <td>
                                <span>20 Ft</span>
                              </td>
                              <td>
                                <span>HQ</span>
                              </td>
                              <td>
                                <span>-</span>
                              </td>
                              <td>
                                <span>13:07:2024 13:52:00</span>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <span>3</span>
                              </td>
                              <td>
                                <span>hjh87787686</span>
                              </td>
                              <td>
                                <span>40 Ft</span>
                              </td>
                              <td>
                                <span>HQ</span>
                              </td>
                              <td>
                                <span>-</span>
                              </td>
                              <td>
                                <span>23:07:2024 13:52:00</span>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <span>4</span>
                              </td>
                              <td>
                                <span>hjh8767676</span>
                              </td>
                              <td>
                                <span>40 Ft</span>
                              </td>
                              <td>
                                <span>HQ</span>
                              </td>
                              <td>
                                <span>-</span>
                              </td>
                              <td>
                                <span>11:07:2024 13:52:00</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Footer />
              <div className="content-backdrop fade" />
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>
    </>
  );
}
